import React from 'react';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function ProblemSection() {
  return <>
      {/* 4. Sección de Problemas */}
      <section className="py-20 px-4 bg-white" data-id="element-228">
        <div className="max-w-4xl mx-auto" data-id="element-229">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-violet-900 mb-12" data-id="element-230">
            ¿Te suena familiar?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-231">
            {['Tus budines salen secos, apelmazados o se hunden en el medio y no entendés por qué.', 'Probás recetas de internet y los resultados son siempre distintos: una vez salen bien, la siguiente un desastre.', 'Querés vender budines pero no sabés cuánto cobrar, cómo conservarlos ni cómo presentarlos.', 'No tenés idea de cómo reemplazar ingredientes cuando te falta algo o querés una versión sin azúcar, sin gluten o sin lácteos.'].map((pain, i) => <div key={i} className="bg-red-50 border border-red-100 p-6 rounded-2xl flex gap-4 items-start" data-id="element-232">
                <XCircle className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-233" />
                <p className="text-lg text-stone-800 font-medium" data-id="element-234">{pain}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 5. Transición Emocional */}
      <section className="py-20 px-4 bg-violet-900 text-center" data-id="element-235">
        <div className="max-w-3xl mx-auto space-y-8" data-id="element-236">
          <p className="text-xl md:text-2xl text-violet-100 leading-relaxed" data-id="element-237">
            Sabemos lo frustrante que es pasar una hora en la cocina, gastar
            ingredientes y terminar con un budín que nadie quiere comer. Y
            también sabemos lo lindo que es cuando el budín sale perfecto y toda
            la familia te pide la receta.
          </p>
          <p className="text-2xl md:text-3xl text-white font-bold leading-tight" data-id="element-238">
            Hacer budines no tiene por qué ser una lotería. Con las recetas
            correctas, las proporciones exactas y los tips de panaderos
            profesionales, cualquier persona puede lograr resultados increíbles
            desde el primer intento.
          </p>
          <p className="text-xl text-violet-200 leading-relaxed" data-id="element-239">
            Y si encima podés convertir esa habilidad en un ingreso extra
            vendiendo budines por encargo, las oportunidades son enormes. Solo
            necesitás el sistema correcto.
          </p>
        </div>
      </section>

      {/* 6. Presentación del Producto */}
      <section className="py-20 px-4 bg-white" data-id="element-240">
        <div className="max-w-5xl mx-auto" data-id="element-241">
          <div className="text-center mb-12" data-id="element-242">
            <h2 className="text-3xl md:text-4xl font-extrabold text-violet-900 mb-4" data-id="element-243">
              Por eso creamos el Mega-Pack 20 Budines Irresistibles
            </h2>
            <p className="text-xl text-stone-600 max-w-3xl mx-auto" data-id="element-244">
              Un sistema completo con 20 recetas probadas, sustituciones para
              cualquier dieta, técnicas de conserva profesional y una guía para
              que empieces a vender desde tu casa.
            </p>
          </div>

          <div className="bg-gradient-to-br from-[#FAF6F0] to-violet-50 rounded-3xl border border-violet-100 p-8 md:p-12" data-id="element-245">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-246">
              {['20 recetas paso a paso con fotos reales, medidas exactas en gramos y mililitros, y tiempos precisos de horno.', 'Versiones clásicas, saludables, sin gluten, sin azúcar y veganas para que cualquier persona pueda disfrutarlas.', 'Tabla de sustituciones para nunca quedarte sin poder cocinar por falta de un ingrediente.', 'Sistema de conserva y freezado profesional para que tus budines duren hasta 3 meses como recién hechos.', 'Guía completa para empezar a vender, con cálculo de precios, presentación y captación de clientes.'].map((benefit, i) => <div key={i} className={`bg-white p-6 rounded-2xl shadow-sm flex gap-4 items-start ${i === 4 ? 'md:col-span-2 md:max-w-xl md:mx-auto' : ''}`} data-id="element-247">
                  <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" data-id="element-248" />
                  <p className="text-stone-800 font-medium" data-id="element-249">{benefit}</p>
                </div>)}
            </div>
            <p className="text-center italic text-violet-700 mt-10 font-medium text-lg" data-id="element-250">
              "El único recetario que vas a necesitar para dominar el arte de
              los budines."
            </p>
          </div>
        </div>
      </section>
    </>;
}